const POPUP_VIEWS_SESSION_STORAGE_KEY = 'popup_session_views';

function incrementPopupSessionViews() {
  const data = Number(sessionStorage.getItem(POPUP_VIEWS_SESSION_STORAGE_KEY));
  return sessionStorage.setItem(POPUP_VIEWS_SESSION_STORAGE_KEY, `${data + 1}`);
}

export function hasExceededViewsPerSession(max_popup_session_views?: number) {
  if (!max_popup_session_views) {
    return false;
  }
  incrementPopupSessionViews();

  return (
    Number(sessionStorage.getItem(POPUP_VIEWS_SESSION_STORAGE_KEY)) >
    max_popup_session_views
  );
}
